export const ViewStudentNotificationPageConfig = {
    headerIcon: "lucide:bell",
    title: "Student Notifications",
    description: "View all published student notifications and their details.",
};
